<div class="d-flex flex-wrap">
  <div class="d-flex align-items-center me-7">
    <span class="fw-bold headline-20 me-3">{{ 'workCouncil.approveLabel' | translate }}:</span>
    <base-button
      class="p-0 rounded-circle w-40px h-40px shadow-none"
      icon="fa-solid fa-check"
      [color]="approveButtonColor"
      iconColor="fw-bold"
      iconClass="fa-solid"
      [disabled]="hasApproveStatus || hasNoteStatus"
      [iconSize]="baseButtonSize.lg"
      [changeDisabledColor]="true"
      (btnClick)="handleStatusChange($event, customerWorkCouncilStatus.APPROVED)"
    ></base-button>
  </div>
  <div class="d-flex align-items-center me-7">
    <span class="fw-bold headline-20 me-3">{{ 'workCouncil.disapproveLabel' | translate }}:</span>
    <base-button
      class="p-0 rounded-circle w-40px h-40px shadow-none"
      icon="fa-solid fa-xmark"
      [color]="disapproveButtonColor"
      iconColor="fw-bold"
      iconClass="fa-solid"
      [disabled]="hasDisapproveStatus || hasApproveStatus || hasNoteStatus"
      [iconSize]="baseButtonSize.xl"
      [changeDisabledColor]="true"
      (btnClick)="handleStatusChange($event, customerWorkCouncilStatus.DISAPPROVED)"
    ></base-button>
  </div>
  <div class="d-flex align-items-center">
    <span class="fw-bold headline-20 me-3">{{ 'workCouncil.notedLabel' | translate }}:</span>
    <base-button
      class="p-0 rounded-circle w-40px h-40px shadow-none"
      icon="fa-solid fa-ellipsis"
      [color]="noteButtonColor"
      iconColor="fw-bold"
      iconClass="fa-solid"
      [disabled]="hasApproveStatus || hasNoteStatus"
      [iconSize]="baseButtonSize.lg"
      [changeDisabledColor]="true"
      (btnClick)="handleStatusChange($event, customerWorkCouncilStatus.NOTED)"
    ></base-button>
  </div>
</div>
